let getCookieValue;

( function($) {

    /**
     * Returns the value of a cookie
     * @param {string} name 
     * @returns {string}
     */
    getCookieValue = function getCookieValue(name) {
        const cookieName = new RegExp(`(^| )${name}=([^;]+)`);
        const cookieValue = document.cookie.match(cookieName);

        if (cookieValue) {
          return cookieValue[2];
        }
    }

})(jQuery);

module.exports = { getCookieValue }